import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'
// https://pinia.vuejs.org/cookbook/composables.html#SSR
export const useWishlistStore = defineStore('wishlistStore', {
  state: () => ({
    wishlist: useStorage('eleven-spectacles-wishlist', new Map())
  }),
  hydrate(state, initialState) {
    // in this case we can completely ignore the initial state since we
    // want to read the value from the browser
    state.wishlist = useStorage('eleven-spectacles-wishlist', new Map())
  },

  getters: {
    items: (wishlistStore) => [...wishlistStore?.wishlist.values()],
    count: (wishlistStore) => [...wishlistStore?.wishlist.values()].length
  },

  actions: {
    toggle(product) {
      if (!this.wishlist.has(product?.stripeProductId)) {
        this.wishlist.set(product?.stripeProductId, { ...product })
      } else {
        this.wishlist.delete(product?.stripeProductId)
      }
    },
    isActive(product) {
      return this.wishlist.has(product?.stripeProductId)
    }
  }
})
